import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { useField } from "formik";
import PTFormInput from "./PTFormInput";
import config from "../../../config";
import { translate } from "../../utils/translate";

export const PTPhoneInput = ({
  name,
  label,
  required,
  isHidden,
  xs = 12,
  md = 4,
  lg = 3,
  gridOptions,
  hiddenLabel,
  placeHolder,
  tooltip,
  height = 40,
  isDisabled = (inputName)=> false,
  ...props
}) => {
  const disabled = isDisabled(name)
  const { formName } = props;
  if (!formName) throw new Error("Parent form is required for PTPhoneInput");
  
  const [field, meta, helpers] = useField(name);
  const showError = meta.touched && !!meta.error;

  const handleChange = (newValue) => {
    helpers.setValue(newValue);
    helpers.setTouched(true);
    
    if (!matchIsValidTel(newValue)) {
      helpers.setError(translate('invalid_phone'));
    } else {
      helpers.setError(undefined);
    }
  };

  return (
    <PTFormInput
      isHidden={isHidden}
      label={label}
      name={name}
      required={required}
      tooltip={tooltip}
      hiddenLabel={hiddenLabel}
      md={md}
      xs={xs}
      lg={lg}
      {...gridOptions}
    >
      <MuiTelInput
        {...field}
        defaultCountry="MA"
        excludedCountries={config.blockedEntity}
        onChange={handleChange}
        placeholder={placeHolder}
        disabled={disabled}
        error={showError}
        helperText={showError && translate(meta.error)}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          sx: {
            height: `${height}px`,
            backgroundColor: disabled ? "#e0e0e0" : "#FFFFFF",
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: showError ? "red" : "rgba(0, 0, 0, 0.23)",
            },
            "& .MuiOutlinedInput-input": {
              boxSizing: "border-box",
              "&:-webkit-autofill": {
                height: "100%",
              },
            },
          }
        }}
        fullWidth
      />
    </PTFormInput>
  );
};

export default PTPhoneInput;